import { FilterFunnel01 } from "@untitledui/icons";
import { Button } from "@/components/base/buttons/button";
import { ButtonGroup } from "@/components/base/button-group/button-group";
import { FilterToggleItem } from "./filter-toggle-item";
import type { RosterFilterSettings } from "./talent-member-list";

interface EmploymentStatusFiltersProps {
  show1099: boolean;
  showW2: boolean;
  showUnclassified: boolean;
  onShow1099Change: (value: boolean) => void;
  onShowW2Change: (value: boolean) => void;
  onShowUnclassifiedChange: (value: boolean) => void;
  onFilterSettingsChange?: (settings: Partial<RosterFilterSettings>) => void;
  onOpenTagFilter: () => void;
  selectedTagCount: number;
}

export const EmploymentStatusFilters = ({
  show1099,
  showW2,
  showUnclassified,
  onShow1099Change,
  onShowW2Change,
  onShowUnclassifiedChange,
  onFilterSettingsChange,
  onOpenTagFilter,
  selectedTagCount,
}: EmploymentStatusFiltersProps) => {
  const selectedKeys = [
    ...(show1099 ? ["1099"] : []),
    ...(showW2 ? ["w2"] : []),
    ...(showUnclassified ? ["unclassified"] : []),
  ];

  return (
    <div className="flex items-center justify-between">
      <ButtonGroup
        size="sm"
        selectionMode="multiple"
        selectedKeys={selectedKeys}
        onSelectionChange={(keys) => {
          const newShow1099 = keys.has("1099");
          const newShowW2 = keys.has("w2");
          const newShowUnclassified = keys.has("unclassified");
          onShow1099Change(newShow1099);
          onShowW2Change(newShowW2);
          onShowUnclassifiedChange(newShowUnclassified);
          onFilterSettingsChange?.({
            show1099: newShow1099,
            showW2: newShowW2,
            showUnclassified: newShowUnclassified,
          });
        }}
      >
        <FilterToggleItem id="1099">1099</FilterToggleItem>
        <FilterToggleItem id="w2">W2</FilterToggleItem>
        <FilterToggleItem id="unclassified">Unclassified</FilterToggleItem>
      </ButtonGroup>
      <Button type="button" color="secondary" onClick={onOpenTagFilter}>
        <FilterFunnel01 className="text-tertiary" />
        {selectedTagCount > 0 && (
          <span className="rounded-full bg-brand-solid text-brand-secondary size-4 flex items-center justify-center text-xs absolute top-0 right-0">
            {selectedTagCount}
          </span>
        )}
      </Button>
    </div>
  );
};
